export default __webpack_public_path__ + "static/media/our-values-banner-mobile.b846e68b.png";